
const ReserveRequest = {
"gdsRefrenceID": "string",
  "phoneNumber": "string",
  "email": "string",
  "note": "string",
  "rooms": [
    {
      "passengers": [
        {
          "firstName": "string",
          "lastName": "string",
          "passengerType": 1,
          "passengerGender": 1,
          "childAge": 0,
          "nationalID": "string",
          "passportNumber": "string"
        }
      ]
    }
  ],
  "hotelTransfers": [
    {
      "transferType": 1,
      "serviceType": 0,
      "airLine": "string",
      "flightNo": "string",
      "arrivalTime": "string",
      "departureTime": "string",
      "phonePassenger": "string"
    }
  ]
  };
 

  export default ReserveRequest;
  